import { useState, useEffect } from 'react'
import api, { ILocationBookableDesk } from '@api'
import { useShouldReload } from '@hooks/reloadContext'

export interface ILocationBookableDeskHook {
  bookableDesks: ILocationBookableDesk[]
  isLoading: boolean
}

export function useLocationBookableDesks(): ILocationBookableDeskHook {
  const [bookableDesks, setBookableDesks] = useState<ILocationBookableDesk[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const shouldReload = useShouldReload()

  useEffect(() => {
    api.company.locationBookableDesks.fetch().then((locationBookableDesks) => {
      setBookableDesks(locationBookableDesks)
      setIsLoading(false)
    })
  }, [shouldReload.locationBookableDesks])

  return { bookableDesks, isLoading }
}
